import { computed, defineComponent } from "vue";
import styles from "./Breadcrumb.module.less";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    // 路由层级
    const matcheds = computed(() => {
      return route.matched;
    })
    // 面包屑内容
    const Matcheds = () => {
      if (route.name === "Index") {
        return <div class={styles["breadcrumb-item"]}>
          首页
        </div>
      } else {
        return <>
          <div class={[styles["breadcrumb-item"], styles.affix]} onClick={() => { router.push("/index") }}>
            首页
          </div>
          {
            matcheds.value.map((item: any) => (
              <>
                <div class={styles.delimiter}></div>
                <div class={styles["breadcrumb-item"]}>
                  {item.meta.title}
                </div>
              </>
            ))
          }
        </>
      }
    }
    return () => (
      <div class={styles.breadcrumb}>
        <Matcheds />
      </div>
    )
  }
})